import React from "react";

import "./LeftLabelToggle.css";
import {Toggle} from "../../toggle/Toggle";

export const LeftLabelToggle = ({labelText, active, setActive}) => {
    return (
        <div className="left-label-toggle-container">
            <label>{labelText}</label>
            <div className="left-label-toggle">
                <Toggle active={active} setActive={setActive}/>
            </div>
        </div>
    );
}